export default "__VITE_ASSET__6PVfMG9o__"